import ApiRequest from '@gry-dmitrij/api-request'

export const apiRequest = new ApiRequest()
